import React from 'react';
import styles from './button.module.css';
import { ButtonProps } from '../../types';

export const Button: React.FC<ButtonProps> = ({
  children,
  id,
  onClick,
  type = 'button',
  variant = 'primary',
  disabled = false,
  showArrow = false,
  width,
  color,
  className,
}) => {
  return (
    <button
      id={id}
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={className ? className : `${styles.button} ${styles[variant]}`}
      style={{ width, color }}
    >
      {children}
      {showArrow && <span className={styles.icon}>→</span>}
    </button>
  );
};
